import {
  MerchantEmailConfigInputSchema,
  MerchantEmailConfigSchema,
} from "@redotech/redo-model/merchant-email-config";
import * as z from "zod/v4";

export const upsertMerchantEmailConfig = {
  name: "upsertMerchantEmailConfig" as const,
  input: z.object({
    id: z.string().optional(),
    config: MerchantEmailConfigInputSchema,
  }),
  output: MerchantEmailConfigSchema,
};
